import { StructuredStorageSlots } from '../../constants';
import { KeyStructuredStorageBaseHelper } from './KeyStructuredStorageBaseHelper';
export class AtStructuredStorageHelper extends KeyStructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.unwrapKeyStructuredStorage({
            type: this.keyType,
            knownType: this.knownKeyType,
        }));
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.type }));
        sb.emitHelper(node, options, sb.helpers.arrReduce({
            each: (innerOptions) => {
                sb.emitHelper(node, innerOptions, sb.helpers.handlePrefixArrayStructuredStorage);
            },
        }));
        sb.emitOp(node, 'TUCK');
        sb.emitPushInt(node, StructuredStorageSlots.size);
        sb.emitOp(node, 'OVER');
        sb.emitPushInt(node, StructuredStorageSlots.size);
        sb.emitOp(node, 'PICKITEM');
        sb.emitPushInt(node, 3);
        sb.emitOp(node, 'ROLL');
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitOp(node, 'ADD');
        sb.emitOp(node, 'SETITEM');
        sb.emitHelper(node, options, sb.helpers.wrapVal({ type: this.type }));
    }
}

//# sourceMappingURL=AtStructuredStorageHelper.js.map
